<template>
  <div
      :class="[
        {
          'ready': loadingIsReady,
          'is-loading': !loadingIsReady,
          'fader': fader
        },
        'loader'
      ]"
  >
    <slot v-if="loadingIsReady"></slot>
    <template v-else>
      <i v-if="showSpinner"
         class="fa fa-spinner fa-pulse"
      ></i>
      <slot name="isLoading"></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: "adivare-results-loading",
  props: {
    showSpinner: {
      type: Boolean,
      default: true,
      required: false
    },
    fader: {
      type: Boolean,
      default: true,
      required: false
    },
    waitFor: {
      type: String,
      default: 'houses',
      required: false
    }
  },
  data() {
    return {
      ready: false,
      changed: false,
      dataLoaders: {
        type: Object,
        default: {},
        required: false,
      }
    }
  },
  mounted() {
    this.dataLoaders = document.querySelectorAll('[data-loader]');
  },
  computed: {
    loadingIsReady() {
      this.ready = (false === this.$store.state.pending[this.waitFor]);
      if (true === this.ready) this.$emit('loadingIsReady');
      this.setReadyToDataAttr();

      return this.ready;
    },
  },
  methods: {
    // Add data-loader attribute in html tag. When ready, the class 'is-ready' is added to tag.
    setReadyToDataAttr() {
      if (this.changed !== this.ready && 0 < this.dataLoaders.length) {
        this.changed = this.ready;
        this.dataLoaders.forEach(dataLoader => true === this.ready ? dataLoader.classList.add('is-ready') : dataLoader.classList.remove('is-ready'));
      }
    }
  }
}
</script>
